import { useRef, useState } from "react";
import { value } from "../../../../../helpers";
import grupoProdutosTributarioXmlValidator from "../../../middlewares/grupo-produtos-tributario-xml.validator";
import {
  Autocomplete,
  Button,
  Grid,
  TextField,
  Tooltip,
} from "../../../../../components";
import { timeoutBuscaAutocomplete } from "../../../../../utils";

export default function GrupoProdutoTributarioXml({
  listaCfop,
  buscarCfops,
  gruposProdutos,
  gruposTributarios,
  listaUnidadesComerciais,
  setProdutos,
  inputErros,
}) {
  const inputRefCfop = useRef();
  const [grupoProdutoTributario, setGrupoProdutoTributario] = useState({});

  const submitGruposIdsProdutos = async (event) => {
    event.preventDefault();
    grupoProdutosTributarioXmlValidator
      .validate(grupoProdutoTributario, { abortEarly: false })
      .then(async () => {
        setProdutos((prevState) =>
          prevState.map((produto) =>
            !produto.usoConsumo
              ? {
                  ...produto,
                  grupoTributacaoId: produto?.grupoTributacaoId
                    ? produto.grupoTributacaoId
                    : grupoProdutoTributario?.grupoTributacaoId,
                  grupoProdutoId: produto?.grupoProdutoId
                    ? produto.grupoProdutoId
                    : grupoProdutoTributario?.grupoProdutoId,
                  cfopId: produto?.cfopId
                    ? produto.cfopId
                    : grupoProdutoTributario?.cfopId,
                  cfop: produto?.cfop
                    ? produto.cfop
                    : grupoProdutoTributario?.cfop,
                  unidadeComercialVendaId: produto?.unidadeComercialVendaId
                    ? produto.unidadeComercialVendaId
                    : grupoProdutoTributario?.unidadeComercialVendaId,
                }
              : produto,
          ),
        );
        inputErros.limpar();
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const handleChangeAutocomplete = (name, value) => {
    setGrupoProdutoTributario({
      ...grupoProdutoTributario,
      [name]: value?.id,
    });
  };

  const onInputChangeCfop = (event) => {
    if (
      event.key === "Enter" &&
      inputRefCfop?.current === document.activeElement
    ) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        timeoutBuscaAutocomplete(buscarCfops(eventValue));
      }
    }
  };

  const handleChangeCfop = (value) => {
    setGrupoProdutoTributario((prevState) => ({
      ...prevState,
      cfopId: value?.id,
      cfop: value?.codigo,
    }));
  };

  return (
    <Grid container spacing={2} alignItems="center" className="mt-3">
      <Grid item xs={2.875}>
        <Autocomplete
          id="grupoProdutoId"
          name="grupoProdutoId"
          options={gruposProdutos}
          noOptionsText="Sem opções"
          autoHighlight
          getOptionLabel={(option) =>
            option.descricao ? option.descricao : ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Grupo de Produto"
              variant="outlined"
              error={inputErros.get("grupoProdutoId")}
            />
          )}
          onChange={(_, value) => {
            handleChangeAutocomplete("grupoProdutoId", value);
          }}
          value={value.autoComplete(
            gruposProdutos,
            grupoProdutoTributario?.grupoProdutoId,
          )}
        />
      </Grid>
      <Grid item xs={2.875}>
        <Autocomplete
          id="grupoTributacaoId"
          name="grupoTributacaoId"
          options={gruposTributarios}
          noOptionsText="Sem opções"
          autoHighlight
          getOptionLabel={(option) => (option.nome ? option.nome : "")}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Grupo Tributário"
              variant="outlined"
              error={inputErros.get("grupoTributacaoId")}
            />
          )}
          onChange={(_, value) => {
            handleChangeAutocomplete("grupoTributacaoId", value);
          }}
          value={value.autoComplete(
            gruposTributarios,
            grupoProdutoTributario?.grupoTributacaoId,
          )}
        />
      </Grid>
      <Grid item xs={2.875}>
        <Autocomplete
          id="cfopId"
          name="cfopId"
          options={listaCfop}
          autoHighlight
          loadingText="Carregando"
          noOptionsText="Digite e pressione Enter"
          getOptionLabel={(option) => option?.descricao?.replace(".", "")}
          filterSelectedOptions
          onChange={(_, newValue) => handleChangeCfop(newValue)}
          value={listaCfop.find(
            (cfop) => cfop?.codigo === grupoProdutoTributario?.cfop,
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="CFOP"
              onKeyDown={onInputChangeCfop}
              inputRef={inputRefCfop}
              error={inputErros.get("cfopId") || inputErros.get("cfop")}
            />
          )}
        />
      </Grid>
      <Grid item xs={2.875}>
        <Autocomplete
          id="unidadeComercialVendaId"
          name="unidadeComercialVendaId"
          options={listaUnidadesComerciais}
          noOptionsText="Sem opções"
          autoHighlight
          disableClearable
          getOptionLabel={(option) =>
            option?.descricao ? option.descricao : ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Unid. Venda"
              error={inputErros.get("unidadeComercialVendaId")}
              variant="outlined"
            />
          )}
          onChange={(_, value) =>
            handleChangeAutocomplete("unidadeComercialVendaId", value)
          }
          value={value.autoComplete(
            listaUnidadesComerciais,
            grupoProdutoTributario?.unidadeComercialVendaId,
          )}
        />
      </Grid>
      <Grid item xs={0.5}>
        <Tooltip title="Clique aqui para confirmar seleção." placement="right">
          <Button
            id="buttonAdicionar"
            variant="contained"
            color="success"
            size="small"
            sx={{
              height: "35px",
              borderRadius: "20%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={(e) => submitGruposIdsProdutos(e)}
          >
            <i
              className="ph-bold ph-plus"
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
